import { layoutClasses } from '@app/player/layout/layout-classes';
var ɵ0 = layoutClasses;
var PlayerModule = /** @class */ (function () {
    function PlayerModule() {
    }
    return PlayerModule;
}());
export { PlayerModule };
export { ɵ0 };
